import { Alert } from "antd";
import { useCompactMode } from "providers/compactModeProvider";
import styled from "styled-components";

const StyledAlert = styled(Alert)`
  width: 100%;
  cursor: pointer;
`;

const StyledLink = styled.span`
  font-weight: 600;
  text-decoration: underline;
`;

function CompactModeToggle() {
  const { isCompactMode, toggleCompactMode } = useCompactMode();

  const label = isCompactMode
    ? "To switch back to classic, click "
    : "To switch to the new look, click ";

  return (
    <StyledAlert
      type="info"
      showIcon
      message={
        <span>
          {label}
          <StyledLink>here</StyledLink>
        </span>
      }
      onClick={toggleCompactMode}
    />
  );
}

export default CompactModeToggle;
